export enum Action {
  VIEW = 'view',
  CLICK = 'click',
  SUBMIT = 'submit',
  TYPING = 'typing',
  OPEN = 'open',
}

export enum Page {
  LANDING_PAGE = 'landing_page',
  PHONE_NUMBER_PAGE = 'phone_number_page',
  EMAIL_PAGE = 'email_page',
  TWO_FACTOR_AUTH_PAGE = 'two_factor_auth_page',
  DISPLAY_NAME_PAGE = 'display_name_page',
  BIRTHDAY_PAGE = 'birthday_page',
  PROFILE_PIC_UPLOAD_PAGE = 'profile_pic_upload_page',
  ASK_DETAILS_PAGE = 'ask_details_page',
  NOTES_PAGE = 'notes_page',
  EXTERNAL_PROFILE_PAGE = 'external_profile_page',
  SEARCH_TAB = 'search_tab',
  CONNECTIONS_TAB = 'connections_tab',
  SELF_TAB = 'self_tab',
  SETTINGS_TAB = 'settings_tab',
  INBOX_TAB = 'inbox_tab',
  MULTI_ASK_DETAILS_PAGE = 'multi_ask_details_page',
  MAIN_NAV_BAR = 'main_nav_bar',
  EMAIL_NOTIFICATION = 'email_notification',
}

export enum ItemType {
  BUTTON = 'button',
  TAB_ICON = 'tab_icon',
  INBOX_ITEM = 'inbox_item',
  AVATAR = 'avatar',
  TOGGLE = 'toggle',
}
